/* import __COLOCATED_TEMPLATE__ from './suggestion-foreword-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import type IntlService from 'embercom/services/intl';
import { inject as service } from '@ember/service';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

interface Signature {
  Args: {};
}

export default class SuggestionForewordItem extends Component<Signature> {
  @service declare intl: IntlService;

  get formattedOverview() {
    let text = this.intl.t(
      'automation.analyze.task-suggestions.api-docs-side-drawer.overview.engineer_review',
    );
    return sanitizeHtml(text);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionForewordItem': typeof SuggestionForewordItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-foreword-item': typeof SuggestionForewordItem;
  }
}
